import React from 'react'


const Hero = () => {
  return (
    <div className='hero-wrapper text-center'>
    <h1 className="text-xxl white-text m-0">YOUR ONE-STOP SHOP FOR</h1>
    <span className="main-text skew"><h1 className='text-xxxl green-text m-0'>WEB3 MERCH</h1>
    <span className="back-text glitch">
    <h1 className='text-xxxl green-text m-0'>WEB3 MERCH</h1>
    </span>
    </span>
    <h4 className='m-2 white-text'>From killer event kits to everyday swag we’ve got it covered.</h4>
</div>
  )
}
export default Hero; 